<template>
  <a-button type="primary" style="align-self: center" @click="showModal">{{ t("login.action.login") }}</a-button>
  <a-modal :width="600" :title="t('login.action.login')" v-model:open="visible" :confirm-loading="confirmLoading" @ok="handleOk" :footer="null">
    <login-form @on-success="handleOk" @on-failure="handleFailure"
      ><template v-slot:message> <a-alert v-if="failure" message="Error" description="Unable to login. Please check your credentials" type="error" /></template
    ></login-form>
  </a-modal>
</template>
<script lang="ts">
import { ref, defineComponent, watch } from "vue";
import { useI18n } from "vue-i18n";
import router from "../router";
import LoginForm from "./LoginForm.vue";
export default defineComponent({
  components: { LoginForm },

  setup() {
    const { t } = useI18n();
    const visible = ref<boolean>(false);
    const confirmLoading = ref<boolean>(false);
    const failure = ref<boolean>(false);
    const showModal = () => {
      visible.value = true;
    };

    const handleOk = () => {
      confirmLoading.value = true;
      failure.value = false;
      setTimeout(() => {
        visible.value = false;
        confirmLoading.value = false;
        router.push("/");
      }, 1000);
    };
    const handleFailure = () => {
      failure.value = true;
    };
    watch(
      () => router.currentRoute.value.path,
      () => {
        if (router.currentRoute.value.query.action) {
          if (router.currentRoute.value.query.action === "login") {
            visible.value = true;
          } else {
            visible.value = false;
          }
        }
      }
    );
    return {
      failure,
      handleFailure,
      visible,
      confirmLoading,
      showModal,
      handleOk,
      t,
    };
  },
});
</script>
